const MOON_PATH = "M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z";
const SUN_PATH = "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z";

const THEME_STORAGE_KEY = "theme";
const DEFAULT_THEME_VARIANT = 2;

function getStoredThemeVariant() {
  const stored = Number(localStorage.getItem(THEME_STORAGE_KEY));
  return stored === 1 || stored === 2 ? stored : DEFAULT_THEME_VARIANT;
}

function applyTheme(themeVariant, themePath) {
  document.body.style.setProperty(
    "--background-color",
    `var(--background-theme${themeVariant})`
  );
  document.body.style.setProperty(
    "--color",
    `var(--color-theme${themeVariant})`
  );
  document.body.style.setProperty("--grey", `var(--grey-theme${themeVariant})`);
  document.body.style.setProperty(
    "--footer",
    `var(--footer-theme${themeVariant})`
  );
  document
    .querySelectorAll("#about, #why-me, .text-color-main")
    .forEach((el) => {
      el.style.setProperty("background-image", "initial");
    });
  if (themePath) {
    themePath.setAttribute("d", themeVariant === 1 ? MOON_PATH : SUN_PATH);
  }
}

export function initTheme() {
  const themeButton = document.querySelector(".change-theme");
  if (!themeButton) return; // Защита профессора: если кнопки нет на странице, код не упадет
  const themePath = themeButton.querySelector("path");
  let themeVariant = getStoredThemeVariant();
  // Применяем сохранённую тему сразу при загрузке, а не только дефолтную
  applyTheme(themeVariant, themePath);
  function changeTheme() {
    themeVariant = themeVariant === 1 ? 2 : 1;
    localStorage.setItem(THEME_STORAGE_KEY, themeVariant);
    applyTheme(themeVariant, themePath);
  }
  themeButton.addEventListener("click", changeTheme);
}